import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { ApprovalStats } from '../../../../../shared/models/sw-part-number/approval-stats';
import { CheckComponent } from '../../../icons/check/check.component';
import { pascalCaseToWords } from '../../../../common/common-utils';

@Component({
  selector: 'app-approval-stats',
  imports: [CheckComponent],
  templateUrl: './approval-stats.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './approval-stats.component.scss',
})
export class ApprovalStatusComponent implements OnChanges {
  @Input() public approvalStatus?: ApprovalStats[];

  public everythingApproved = false;
  protected pascalCaseToWords = pascalCaseToWords;

  public ngOnChanges(): void {
    if (!this.approvalStatus) {
      this.everythingApproved = false;
    }

    this.everythingApproved =
      this.approvalStatus?.every((item) => item.pendingCount == 0 && item.todoCount == 0) ?? false;
  }
}
